import React from 'react';
import { XIcon, DownloadIcon, PrinterIcon } from 'lucide-react';
interface DocumentPreviewProps {
  document: any;
  onClose: () => void;
}
export function DocumentPreview({
  document,
  onClose
}: DocumentPreviewProps) {
  return <div className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden" data-id="element-133">
      <div className="flex items-center justify-between p-4 border-b border-neutral-200" data-id="element-134">
        <h2 className="text-xl font-medium text-neutral-900" data-id="element-135">
          {document.fileName}
        </h2>
        <div className="flex items-center space-x-2" data-id="element-136">
          <button onClick={() => {}} className="p-1 text-neutral-400 hover:text-neutral-600" title="Download" data-id="element-137">
            <DownloadIcon className="h-5 w-5" data-id="element-138" />
          </button>
          <button onClick={() => {}} className="p-1 text-neutral-400 hover:text-neutral-600" title="Print" data-id="element-139">
            <PrinterIcon className="h-5 w-5" data-id="element-140" />
          </button>
          <button onClick={onClose} className="p-1 text-neutral-400 hover:text-neutral-600" title="Close" data-id="element-141">
            <XIcon className="h-5 w-5" data-id="element-142" />
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-0" data-id="element-143">
        {/* Document Preview Pane */}
        <div className="col-span-2 border-r border-neutral-200 p-4 min-h-[600px] bg-neutral-50 flex items-center justify-center" data-id="element-144">
          {document.type === 'Bank Statement' ? <div className="w-full max-w-2xl p-6 bg-white shadow-md" data-id="element-145">
              <div className="text-center mb-6" data-id="element-146">
                <h3 className="text-xl font-bold text-primary-800" data-id="element-147">
                  Meridian Financial Bank
                </h3>
                <p className="text-neutral-600" data-id="element-148">High-Yield Savings Statement</p>
              </div>
              <div className="mb-4" data-id="element-149">
                <h4 className="text-lg font-semibold mb-2" data-id="element-150">Account Holder</h4>
                <p data-id="element-151">Lucas Scheer</p>
              </div>
              <div className="mb-4" data-id="element-152">
                <h4 className="text-lg font-semibold mb-2" data-id="element-153">Account Summary</h4>
                <table className="w-full border-collapse" data-id="element-154">
                  <tbody data-id="element-155">
                    <tr className="border-b" data-id="element-156">
                      <td className="py-2 text-neutral-600" data-id="element-157">Account Number:</td>
                      <td className="py-2 text-right" data-id="element-158">****5678</td>
                    </tr>
                    <tr className="border-b" data-id="element-159">
                      <td className="py-2 text-neutral-600" data-id="element-160">
                        Statement Period:
                      </td>
                      <td className="py-2 text-right" data-id="element-161">
                        Oct 1, 2024 - Jan 31, 2025
                      </td>
                    </tr>
                    <tr className="border-b" data-id="element-162">
                      <td className="py-2 text-neutral-600" data-id="element-163">
                        Opening Balance:
                      </td>
                      <td className="py-2 text-right" data-id="element-164">$15,892.45</td>
                    </tr>
                    <tr className="border-b" data-id="element-165">
                      <td className="py-2 text-neutral-600" data-id="element-166">
                        Closing Balance:
                      </td>
                      <td className="py-2 text-right font-bold" data-id="element-167">$45,892.45</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div data-id="element-168">
                <h4 className="text-lg font-semibold mb-2" data-id="element-169">
                  Transaction Summary
                </h4>
                <table className="w-full border-collapse" data-id="element-170">
                  <thead data-id="element-171">
                    <tr className="border-b" data-id="element-172">
                      <th className="py-2 text-left" data-id="element-173">Date</th>
                      <th className="py-2 text-left" data-id="element-174">Description</th>
                      <th className="py-2 text-right" data-id="element-175">Amount</th>
                    </tr>
                  </thead>
                  <tbody data-id="element-176">
                    <tr className="border-b" data-id="element-177">
                      <td className="py-2" data-id="element-178">Jan 18, 2025</td>
                      <td className="py-2" data-id="element-179">Transfer from Investment Account</td>
                      <td className="py-2 text-right text-success-600" data-id="element-180">
                        +$30,000.00
                      </td>
                    </tr>
                    <tr className="border-b" data-id="element-181">
                      <td className="py-2" data-id="element-182">Dec 15, 2024</td>
                      <td className="py-2" data-id="element-183">Interest Payment</td>
                      <td className="py-2 text-right text-success-600" data-id="element-184">
                        +$58.32
                      </td>
                    </tr>
                    <tr className="border-b" data-id="element-185">
                      <td className="py-2" data-id="element-186">Nov 15, 2024</td>
                      <td className="py-2" data-id="element-187">Interest Payment</td>
                      <td className="py-2 text-right text-success-600" data-id="element-188">
                        +$41.68
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> : <div className="text-center text-neutral-500" data-id="element-189">
              <p data-id="element-190">Preview not available</p>
              <p className="text-sm" data-id="element-191">Download the document to view</p>
            </div>}
        </div>
        {/* AI Analysis Pane */}
        <div className="col-span-1 p-4" data-id="element-192">
          <div className="mb-6" data-id="element-193">
            <h3 className="text-lg font-medium text-neutral-900 mb-3" data-id="element-194">
              AI Analysis
            </h3>
            <div className="bg-neutral-50 rounded-md p-4 mb-4" data-id="element-195">
              <h4 className="text-sm font-medium text-neutral-500 mb-1" data-id="element-196">
                Document Type
              </h4>
              <p className="text-base text-neutral-900" data-id="element-197">{document.type}</p>
            </div>
            {document.aiAnalysis && <div className="space-y-4" data-id="element-198">
                <div className="bg-neutral-50 rounded-md p-4" data-id="element-199">
                  <h4 className="text-sm font-medium text-neutral-500 mb-1" data-id="element-200">
                    Document Details
                  </h4>
                  <div className="grid grid-cols-2 gap-3 mt-3" data-id="element-201">
                    {document.aiAnalysis.institution && <div data-id="element-202">
                        <p className="text-xs text-neutral-500" data-id="element-203">Institution:</p>
                        <p className="text-sm font-medium text-neutral-900" data-id="element-204">
                          {document.aiAnalysis.institution}
                        </p>
                      </div>}
                    {document.aiAnalysis.account && <div data-id="element-205">
                        <p className="text-xs text-neutral-500" data-id="element-206">Account:</p>
                        <p className="text-sm font-medium text-neutral-900" data-id="element-207">
                          {document.aiAnalysis.account}
                        </p>
                      </div>}
                    {document.aiAnalysis.keyPersons && <div className="col-span-2" data-id="element-208">
                        <p className="text-xs text-neutral-500" data-id="element-209">Key Persons:</p>
                        <p className="text-sm font-medium text-neutral-900" data-id="element-210">
                          {document.aiAnalysis.keyPersons.join(', ')}
                        </p>
                      </div>}
                    {document.aiAnalysis.dateRange && <div className="col-span-2" data-id="element-211">
                        <p className="text-xs text-neutral-500" data-id="element-212">Date Range:</p>
                        <p className="text-sm font-medium text-neutral-900" data-id="element-213">
                          {new Date(document.aiAnalysis.dateRange.start).toLocaleDateString()}{' '}
                          -{' '}
                          {new Date(document.aiAnalysis.dateRange.end).toLocaleDateString()}
                        </p>
                      </div>}
                  </div>
                </div>
                <div className="bg-neutral-50 rounded-md p-4" data-id="element-214">
                  <h4 className="text-sm font-medium text-neutral-500 mb-1" data-id="element-215">
                    Summary
                  </h4>
                  <p className="text-sm text-neutral-700 whitespace-pre-line" data-id="element-216">
                    {document.aiAnalysis.summary}
                  </p>
                </div>
              </div>}
          </div>
          <div className="mt-6" data-id="element-217">
            <h3 className="text-lg font-medium text-neutral-900 mb-3" data-id="element-218">
              Actions
            </h3>
            <div className="space-y-2" data-id="element-219">
              <button className="w-full py-2 px-4 bg-primary-600 hover:bg-primary-700 text-white rounded-md text-sm font-medium" data-id="element-220">
                Download Document
              </button>
              <button className="w-full py-2 px-4 border border-neutral-300 text-neutral-700 hover:bg-neutral-50 rounded-md text-sm font-medium" data-id="element-221">
                Regenerate Analysis
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}